import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Header } from '../../app/components';
import { ResponsiveMenu } from '../../common/components/hoc';
import {
  selectIsLoggedIn,
  selectAccount,
  selectAccountEmail,
  logout,
  selectIsDebtor,
  selectIsCreditor,
  selectIsExecutor,
} from '../../features/auth/ducks';

const mapStateToProps = state => ({
  isLoggedIn: selectIsLoggedIn(state),
  isDebtor: selectIsDebtor(state),
  isCreditor: selectIsCreditor(state),
  isExecutor: selectIsExecutor(state),
  email: selectAccount(state) && selectAccountEmail(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ logout }, dispatch),
});

@ResponsiveMenu()
@connect(mapStateToProps, mapDispatchToProps)
export default class HeaderContainer extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    menuMode: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    isCreditor: PropTypes.bool.isRequired,
    isDebtor: PropTypes.bool.isRequired,
    isExecutor: PropTypes.bool,
    email: PropTypes.string,
  };

  state = {
    responsiveMenuVisible: false,
  };

  componentDidMount() {
    this.context.router.listen(this.hideResponsiveMenu);
  }

  componentWillUnmount() {
    this.context.router.unsubscribe(this.hideResponsiveMenu);
  }

  showResponsiveMenu = () => {
    this.setState({ responsiveMenuVisible: true });
  };

  hideResponsiveMenu = () => {
    this.setState({ responsiveMenuVisible: false });
  };

  toggleResponsiveMenu = responsiveMenuVisible => {
    this.setState({ responsiveMenuVisible });
  };

  render() {
    const { actions, isLoggedIn, isCreditor, isDebtor, isExecutor, menuMode, email } = this.props;
    const { responsiveMenuVisible } = this.state;

    return (
      <Header
        email={email}
        isLoggedIn={isLoggedIn}
        isCreditor={isCreditor}
        isDebtor={isDebtor}
        isExecutor={isExecutor}
        logout={actions.logout}
        responsiveMenuVisible={responsiveMenuVisible}
        menuMode={menuMode}
        showResponsiveMenu={this.showResponsiveMenu}
        hideResponsiveMenu={this.hideResponsiveMenu}
        toggleResponsiveMenu={this.toggleResponsiveMenu}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/HeaderContainer.js